import React from 'react';
import IconType from './iconType';

function CommentIcon({ width = 18, height = 18, color = 'white' }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <title>CommentIcon</title>
      <mask id="path-1-inside-1_17509_43547" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.452 17.6443C22.4375 15.9959 23.0039 14.068 23.0039 12.0078C23.0039 5.93268 18.079 1.00781 12.0039 1.00781C5.92877 1.00781 1.00391 5.93268 1.00391 12.0078C1.00391 18.0829 5.92877 23.0078 12.0039 23.0078C14.0644 23.0078 15.9926 22.4413 17.6412 21.4554L22.847 22.8503L21.452 17.6443Z"
        />
      </mask>
      <path
        d="M21.452 17.6443L19.5392 16.5007C19.2299 17.0182 19.1434 17.6388 19.2994 18.2211L21.452 17.6443ZM17.6412 21.4554L18.218 19.3028C17.6357 19.1468 17.0149 19.2333 16.4975 19.5428L17.6412 21.4554ZM22.847 22.8503L22.2702 25.0029C23.0392 25.209 23.8598 24.9891 24.4228 24.4261C24.9858 23.8632 25.2057 23.0426 24.9996 22.2735L22.847 22.8503ZM20.7753 12.0078C20.7753 13.6542 20.3239 15.1884 19.5392 16.5007L23.3648 18.7879C24.5512 16.8035 25.2325 14.4818 25.2325 12.0078H20.7753ZM12.0039 3.23638C16.8482 3.23638 20.7753 7.16349 20.7753 12.0078H25.2325C25.2325 4.70187 19.3098 -1.22076 12.0039 -1.22076V3.23638ZM3.23248 12.0078C3.23248 7.16349 7.15958 3.23638 12.0039 3.23638V-1.22076C4.69797 -1.22076 -1.22467 4.70187 -1.22467 12.0078H3.23248ZM12.0039 20.7792C7.15958 20.7792 3.23248 16.8521 3.23248 12.0078H-1.22467C-1.22467 19.3138 4.69797 25.2364 12.0039 25.2364V20.7792ZM16.4975 19.5428C15.185 20.3276 13.6506 20.7792 12.0039 20.7792V25.2364C14.4783 25.2364 16.8003 24.5549 18.785 23.3681L16.4975 19.5428ZM17.0644 23.6081L22.2702 25.0029L23.4238 20.6977L18.218 19.3028L17.0644 23.6081ZM24.9996 22.2735L23.6046 17.0675L19.2994 18.2211L20.6943 23.4271L24.9996 22.2735Z"
        fill={color}
        mask="url(#path-1-inside-1_17509_43547)"
      />
    </svg>
  );
}

export default CommentIcon;
